import Script from 'next/script';

/**
 * Renders the Zendesk messaging widget when `NEXT_PUBLIC_CHATBOT_PROVIDER` selects it.
 * Environments without a chatbot leave the provider unset.
 */
export const ZendeskChatbot = () => {
    const widgetKey = process.env.NEXT_PUBLIC_ZENDESK_WIDGET_KEY;

    if (process.env.NEXT_PUBLIC_CHATBOT_PROVIDER !== 'zendesk' || !widgetKey) {
        return null;
    }

    // Zendesk's loader finds itself by the `ze-snippet` id to read the widget key, so it can't be renamed.
    return <Script id="ze-snippet" src={`https://static.zdassets.com/ekr/snippet.js?key=${widgetKey}`} strategy="lazyOnload" />;
};
